module.exports = __webpack_public_path__ + "static/img/IMG_20240405_082519.8dbfde3c.jpg";